import { render, staticRenderFns } from "./VuesticColorDropdown.vue?vue&type=template&id=d38b54ac&"
import script from "./VuesticColorDropdown.vue?vue&type=script&lang=js&"
export * from "./VuesticColorDropdown.vue?vue&type=script&lang=js&"
import style0 from "./VuesticColorDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticColorDropdown.vue"
export default component.exports